import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 20px' }}>
      <div style={{ maxWidth: '800px', textAlign: 'left' }}>
        <h1 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '1rem' }}>Privacy Policy – Econirmit</h1>
        <p><strong>Website:</strong> <a href="https://econirmit.com" target="_blank" rel="noopener noreferrer">https://econirmit.com</a></p>

        <h2>1. Overview</h2>
        <p>Econirmit prioritizes the privacy of its visitors.</p>
        <p>This Privacy Policy outlines the type of information collected and how it is used.</p>
        <p>The policy applies only to online activities and not to data collected offline or via other channels.</p>

        <h2>2. Consent</h2>
        <p>By using our website, you consent to our Privacy Policy and agree to its terms.</p>

        <h2>3. Information We Collect</h2>
        <p>Information provided at the time of collection will be clearly communicated.</p>
        <p>If you contact us, we may collect:</p>
        <ul>
          <li>Name, email address, phone number</li>
          <li>Message content and any attachments</li>
        </ul>
        <p>If you register for an account, we may ask for:</p>
        <ul>
          <li>Name, company name, address, email, and telephone number</li>
        </ul>

        <h2>4. How We Use Your Information</h2>
        <ul>
          <li>To provide, operate, and maintain our website</li>
          <li>To improve and personalize the user experience</li>
          <li>To analyze and understand website usage</li>
          <li>To develop new services and features</li>
          <li>To communicate with you directly or via partners</li>
          <li>To send updates, marketing, and promotional materials</li>
          <li>To send emails</li>
          <li>To detect and prevent fraud</li>
        </ul>

        <h2>5. Log Files</h2>
        <p>Econirmit uses log files as part of standard hosting analytics.</p>
        <p>These may include:</p>
        <ul>
          <li>IP addresses, browser type, ISP, timestamp, referring/exit pages, number of clicks</li>
        </ul>
        <p>Data is not linked to personally identifiable information.</p>
        <p>Used for trend analysis, site administration, and user behavior tracking.</p>

        <h2>6. Cookies and Web Beacons</h2>
        <p>Cookies store visitor preferences and page access details.</p>
        <p>Used to optimize user experience by customizing content based on browser type and other data.</p>

        <h2>7. Google DoubleClick DART Cookie</h2>
        <p>Google uses DART cookies to serve ads based on user activity.</p>
        <p>Users may opt out via: <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Google Ads Policy</a></p>

        <h2>8. Advertising Partners</h2>
        <p>Third-party advertisers may use cookies and web beacons.</p>
        <p>These technologies help in measuring ad effectiveness and personalizing content.</p>
        <p>Econirmit has no access to or control over these third-party cookies.</p>
        <p><strong>Primary Advertising Partner:</strong><br />
          Google – <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        </p>

        <h2>9. Third-Party Privacy Policies</h2>
        <p>Econirmit's Privacy Policy does not cover other advertisers or websites.</p>
        <p>Users should consult the respective third-party Privacy Policies for more information.</p>
        <p>Cookie preferences can be managed in your browser settings.</p>

        <h2>10. CCPA Privacy Rights (California Residents)</h2>
        <p>Under the California Consumer Privacy Act (CCPA), you have the right to:</p>
        <ul>
          <li>Know what personal data is collected</li>
          <li>Request deletion of your personal data</li>
          <li>Opt-out of the sale of personal data</li>
        </ul>
        <p>If you wish to exercise these rights, contact us. We will respond within one month.</p>

        <h2>11. GDPR Data Protection Rights (EU Residents)</h2>
        <p>You have the following rights:</p>
        <ul>
          <li><strong>Access</strong> – Request copies of your personal data</li>
          <li><strong>Rectification</strong> – Request correction of inaccurate/incomplete data</li>
          <li><strong>Erasure</strong> – Request deletion of your data (under certain conditions)</li>
          <li><strong>Restrict Processing</strong> – Request limitation of data processing (under certain conditions)</li>
          <li><strong>Object to Processing</strong> – Object to processing of your data (under certain conditions)</li>
          <li><strong>Data Portability</strong> – Request transfer of your data to another organization or to you</li>
        </ul>
        <p>To exercise these rights, contact us. We will respond within one month.</p>

        <h2>12. Children’s Information</h2>
        <p>Econirmit does not knowingly collect data from children under the age of 13.</p>
        <p>Parents and guardians are encouraged to monitor children's internet use.</p>
        <p>If such information has been unintentionally collected, please contact us to have it removed.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
